export default __webpack_public_path__ + "assets/images/aistudio/empty_state/bc06e4349a1cdccd1bc86358f5b04778.png";